import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
	root: {},
	hide: {
		display: 'none'
	}
}));